export const NAV_ITEMS = ["Recubriendo el mundo", "Tapicerias técnicas", "Productos", "Proyectos"]
